export default __webpack_public_path__ + "static/media/morning-icon.a31890dc.svg";